var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10.1785L11.2045 3.47404C11.6438 3.0347 12.3562 3.0347 12.7955 3.47404L19.5 10.1785V20.3035C19.5 20.9249 18.9963 21.4285 18.375 21.4285H16.5H14.25H9.75H8.25H5.625C5.00368 21.4285 4.5 20.9249 4.5 20.3035V10.1785Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 12.4285L11.2045 3.47404C11.6438 3.0347 12.3562 3.0347 12.7955 3.47404L21.75 12.4285M4.5 10.1785V20.3035C4.5 20.9249 5.00368 21.4285 5.625 21.4285H9.75V16.5535C9.75 15.9322 10.2537 15.4285 10.875 15.4285H13.125C13.7463 15.4285 14.25 15.9322 14.25 16.5535V21.4285H18.375C18.9963 21.4285 19.5 20.9249 19.5 20.3035V10.1785M8.25 21.4285H16.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.aaef33719ba9d72057f09c6faa1ed22a.svg";
export { ForwardRef as ReactComponent };